import MDAlert from "components/MDAlert";
import MDBox from "components/MDBox";
import DataTable from "components/Tables/DataTable/DataTable";
import TableSkeleton from "components/TableSkeleton/TableSkeleton";
import useOpportunitiesTable from "hooks/opportunities/useOpportunitiesTable";

export default function OpportunitiesList({ headerRight }: { headerRight?: React.ReactNode }) {
  // Get the companies list
  const { loading, error, tableData, pagination, filtering, sorting, searchControl } =
    useOpportunitiesTable();

  return (
    <>
      <MDBox mb={3} display="flex" alignItems="center" justifyContent="space-between" gap={2}>
        <MDBox flex="1 1 auto">{searchControl}</MDBox>
        {headerRight ? <MDBox flex="0 0 auto">{headerRight}</MDBox> : null}
      </MDBox>
      {(loading || error) && (
        <div style={{ padding: "16px" }}>
          {loading && <TableSkeleton numberOfLines={pagination.pageSize} />}
          {error && <MDAlert color="error">{error.message}</MDAlert>}
        </div>
      )}
      {!loading && !error && (
        <MDBox
          sx={{
            "& .wrapper-table th": {
              paddingLeft: "12px",
              paddingRight: "12px",
              paddingTop: "8px",
              paddingBottom: "8px",
            },
            "& .wrapper-table td": {
              paddingLeft: "12px",
              paddingRight: "12px",
              paddingTop: "6px",
              paddingBottom: "6px",
            },
            "& .wrapper-table td .MuiTypography-caption": {
              fontSize: "0.7rem",
            },
          }}
        >
          <DataTable
            table={tableData}
            pagination={pagination}
            filtering={filtering}
            sorting={sorting}
            isSorted={true}
            displayScrollTop={true}
          />
        </MDBox>
      )}
    </>
  );
}
